// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"cfca333c","453":"cf4d73b5"}[chunkId] + ".chunk.js";
};